import { extractPage, searchPageParams } from "../springdata";

export function asFormData(json, fichiers, info = {}) {
    const formData = new FormData();
    const nom = info.document;
    formData.append(
        nom,
        new Blob([JSON.stringify(json)], { type: "application/json" })
    );

    var promises = [];
    var index = 0;
    for (const fichier of fichiers) {
        promises.push(verifieFichier(fichier, index));
        formData.append("fichier", fichier);
        index++;
    }

    return Promise.all(promises).then(() => {
        return formData;
    });
}

function verifieFichier(fichier, index) {
    return new Promise((resolve, reject) => {
        const fReader = new FileReader();

        fReader.onload = () => {
            resolve();
        }

        fReader.onerror = () => {
            reject({
                name: "Error",
                message: "Fichier inaccessible ou endommagé. Les erreurs sont indiquées en rouge.",
                response: {
                    data: {
                        fieldErrors: [
                            {
                                field: `documents[${index}]`,
                                defaultMessage: "Fichier inaccessible ou endommagé"
                            }
                        ]
                    }
                }
            });
        }

        fReader.readAsDataURL(fichier);
    });
}

function estMembreSupprime(m) {
    return m.action === "supprime";
}


function nettoyageSupprimeComite(comite, indexExistant) {
    const indexMembres = indexExistant.filter(i => {
        const { collection, index } = i;
        if (collection && estMembreSupprime(comite[collection][index])) {
            return false;
        }
        return true;
    });

    return {
        morales: nettoyageActionSupprime(comite.morales),
        physiques: nettoyageActionSupprime(comite.physiques),
        reprises: nettoyageActionSupprime(comite.reprises),
        indexMembres,
    };
}


function nettoyageActionSupprime(liste) {
    if (liste) {
        return liste.map(l => !estMembreSupprime(l) ? l : null);
    }
    return liste;
}

export default class RequeteService{
    constructor(axios, snackbar) {
        this.axios = axios;
        this.snackbar = snackbar;
    }

    listeRequetes(search, pagination) {
        return this.axios
            .get("/api/requete", { params: searchPageParams(search, pagination) })
            .catch(this.snackbar.catch())
            .then(response => extractPage(response.data));
    }

    chargeRequete(numero) {
        return this.axios
            .get(`/api/requete/${numero}`)
            .catch(this.snackbar.catch())
            .then(response => response.data);
    }

    depot(id) {
        return this.axios
            .get(`/api/depot/${id}`).then(response => response.data);
    }

    validationDocument(mode, document, fichier) {
        return asFormData(document, [fichier], { document: "document" }).catch(error => {
            throw error;
        }).then(formData => {
            return this.axios
                .post(`/api/requete/document/${mode}`, formData)
                .then(response => response.data);
        });
    }

    creer({ declarant, association, annexes, membres, commentaire }) {
        const asso = {
            commentaire,
            association,
            declarant,
            fondateurs: membres.fondateurs,
            comite: nettoyageSupprimeComite(membres.comite, membres.indexMembres),
            documents: annexes.map(a => ({ type: a.type, date: a.date, sousType: a.sousType })),
        }

        const fichiers = annexes.map(a => a.fichier);


        return asFormData(asso, fichiers, { document: "association" }).catch(error => {
            throw error;
        }).then(formData => {
            return this.axios
                .post("/api/requete/creation", formData)
                .then(response => response.data);
        });
    }

    modifier(numero, { declarant, decision, association, annexes, membres, commentaire }) {
        const asso = {
            commentaire,
            association,
            declarant,
            decision: {
                type: decision,
            },
            renouvellementComite: membres.renouvellementComite,
            comite: nettoyageSupprimeComite(membres.comite, membres.indexMembres),
            documents: annexes,
        }

        const fichiers = annexes.map(a => a.fichier);
        return asFormData(asso, fichiers, { document: "association" }).catch(error => {
            throw error;
        }).then(formData => {
            return this.axios
                .post(`/api/requete/modification/${numero}`, formData)
                .then(response => response.data);
        });
    }

    dissoudre(numero, { declarant, annexes, dissolution, commentaire }) {
        const asso = {
            commentaire,
            dissolution: {
                ...dissolution,
                decision: {
                    type: dissolution.decision,
                },
            },
            declarant,
            documents: annexes,
        }

        const fichiers = annexes.map(a => a.fichier);
        return asFormData(asso, fichiers, { document: "association" }).catch(error => {
            throw error;
        }).then(formData => {
            return this.axios
                .post(`/api/requete/dissolution/${numero}`, formData)
                .then(response => response.data);
        });
    }

    radier(numero, { declarant, annexes, radiation, commentaire }) {
        const asso = {
            commentaire,
            radiation,
            declarant,
            documents: annexes,
        }

        const fichiers = annexes.map(a => a.fichier);
        return asFormData(asso, fichiers, { document: "association" }).catch(error => {
            throw error;
        }).then(formData => {
            return this.axios
                .post(`/api/requete/radiation/${numero}`, formData)
                .then(response => response.data);
        });
    }
}
